export default "__VITE_PUBLIC_ASSET__05fee94f__"